export const hasAnyChange = (obj1 = {}, obj2 = {}, ignoreExtraKeys = true) => {
  try {
    const isEmptyObject = obj => {
      return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
    };

    if (isEmptyObject(obj1) || isEmptyObject(obj2)) {
      return { changed: true, changedKeys: [] };
    }

    const keys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);
    const changedKeys = [];

    for (const key of keys) {
      if (ignoreExtraKeys && (!(key in obj1) || !(key in obj2))) continue;

      const val1 = obj1?.[key];
      const val2 = obj2?.[key];

      if (val1 !== val2) {
        changedKeys.push(key);
      }
    }

    return { changed: changedKeys.length > 0, changedKeys };
  } catch (error) {
    console.error('hasAnyChange error:', error);
    return { changed: false, changedKeys: [] };
  }
};
